import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

const sectionSx = {
  border: '1px solid #E0E0E0',
  borderRadius: 1.5,
  p: { xs: 1.5, sm: 2 },
  bgcolor: '#fff'
};

export const IssueDialogSection = ({ title, children }: { title: string; children: ReactNode }) => (
  <Stack gap={2} sx={sectionSx}>
    <Typography fontWeight={700} color="#226AAA" fontSize={{ xs: 15, sm: 16 }}>
      {title}
    </Typography>
    {children}
  </Stack>
);

export const IssueMetaGrid = ({ items }: { items: { label: string; value?: string | null }[] }) => (
  <Box
    display="grid"
    gridTemplateColumns={{ xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }}
    gap={{ xs: 1.5, sm: 2 }}>
    {items.map((item) => (
      <Stack key={item.label} gap={0.5} minWidth={0}>
        <Typography fontWeight={700} fontSize={13}>
          {item.label}
        </Typography>
        <Typography fontSize={14} whiteSpace="pre-line" sx={{ wordBreak: 'break-word' }}>
          {item.value || '-'}
        </Typography>
      </Stack>
    ))}
  </Box>
);

export const IssuePhotosGrid = ({ children }: { children: ReactNode }) => (
  <Box
    display="grid"
    gridTemplateColumns={{ xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }}
    gap={2}
    width="100%">
    {children}
  </Box>
);

export const IssueWorkflowDialogLayout = ({
  main,
  sessions
}: {
  main: ReactNode;
  sessions?: ReactNode;
}) => (
  <Stack
    direction={{ xs: 'column', xl: 'row' }}
    gap={2}
    width="100%"
    alignItems="stretch"
    sx={{ minHeight: 0 }}>
    <Stack flex="1 1 auto" minWidth={0} gap={2}>
      {main}
    </Stack>
    {sessions ? (
      <Stack
        flex={{ xs: '0 0 auto', xl: '0 0 340px' }}
        minWidth={{ md: 280 }}
        maxWidth={{ xl: 380 }}
        sx={sectionSx}>
        {sessions}
      </Stack>
    ) : null}
  </Stack>
);
